import { render, staticRenderFns } from "./OperaChangeIntegralWindow.vue?vue&type=template&id=0f044b64&scoped=true&"
import script from "./OperaChangeIntegralWindow.vue?vue&type=script&lang=js&"
export * from "./OperaChangeIntegralWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaChangeIntegralWindow.vue?vue&type=style&index=0&id=0f044b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f044b64",
  null
  
)

export default component.exports